export const OriginOfSurveyResponseEnum = {
    PORTAL: 1,
    CALLED_CREATION: 2,
    NOTIFICATION: 3,
    EMAIL: 4,
    WHATSAPP: 5
};